module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "area",
    class: _vm.area.id
  }, [_c('div', {
    staticClass: "ui top attached header"
  }, [_vm._v("\n        " + _vm._s(_vm.area.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "ui attached basic segment"
  }, [_c('div', {
    staticClass: "ui three column grid"
  }, _vm._l((_vm.area.metrics), function(m) {
    return _c('metric-widget', {
      key: m,
      attrs: {
        "metric": {
          name: m
        },
        "area": _vm.area.id
      }
    })
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f2502aa8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardArea.vue
// module id = 401
// module chunks = 1